import type { RouteRecordRaw } from 'vue-router';

import { Path } from '@/platform/routing/targets';

const notificationsRoutes: RouteRecordRaw[] = [
  {
    path: Path.Notification,
    name: 'notification-list',
    component: () => import('@/domains/notifications/views/NotificationListView.vue'),
    meta: { renderer: 'native', layout: 'notification' },
  },
];

export default notificationsRoutes;
